import { LOCAL__generation_upsert_generation } from '@/state/generation/entity/LOCAL__generation_upsert_generation';
import { store } from '@/state/store';
import { get_entity_with_sorted_tokens_generation } from '@/state/words/_methods/get_entity_with_sorted_tokens_generation';
import { DTO__word } from '@shared/dto/+word/word_translated/DTO__word';
import { DTO__generation } from '@shared/dto/generation/DTO__generation';
import { logi } from '@shared/utils/utils_logs';
import { establish_word_object_for_tokens } from './_methods/establish_word_object_for_tokens';
import { SERVICE__translate_base } from './SERVICE__translate_base';

class SERVICE__translate_generations extends SERVICE__translate_base {
  /*
   * EVENTS
   */
  on_generations_received(generations: DTO__generation[]) {
    logi('register words dependency for compel');

    // for (let generation of generations) {
    //   let words_strings = generation.settings.tokens.map(token => token.word_english);

    //   this.register_words_dependency(generation._id, words_strings);
    // }
  }

  on_language_changed() {
    let slice_workspace = store.getState().slice_workspace;
    if (!slice_workspace.is_all_data_loaded) return;

    let slice_generation = store.getState().slice_generation;

    let entities = Array.from(slice_generation.generations_map.values());

    //reset words for all searches to english or get translation from vocabulary
    for (let entity of entities) {
      entity.settings.tokens = establish_word_object_for_tokens(entity.settings.tokens);
    }

    store.dispatch(LOCAL__generation_upsert_generation(entities));
  }

  /*
   * METHODS
   */

  protected try_update_depended_entity_with_word(word: DTO__word) {
    let slice_generation = store.getState().slice_generation;

    let entities_ids = this.words_dependencies_map.get_or_create_set(word.word_english);

    for (let entity_id of entities_ids) {
      let generation = slice_generation.generations_map.get(entity_id);
      if (!generation) continue; //generation deleted

      generation.settings.tokens = generation.settings.tokens.map(token => (token.word_english == word.word_english ? token.clone({ word }) : token));

      generation = get_entity_with_sorted_tokens_generation(generation);

      store.dispatch(LOCAL__generation_upsert_generation([generation]));
    }
  }
}

export const service_translate_generations = new SERVICE__translate_generations();
